import { Bell } from "lucide-react";
import { DateTimePicker } from "@/components/tasks/DateTimePicker";

// Reminder is a date+time field. It reuses the canonical DateTimePicker so it
// shares the exact same interaction, overlay and accessibility behaviour as
// every other ContentOS date/time control. Past dates are not selectable for a
// reminder. Value contract unchanged: "YYYY-MM-DDTHH:mm" naive local time.
export function ReminderPicker({ value, onChange, testid = "drawer-reminder" }) {
  return (
    <DateTimePicker
      value={value}
      onChange={onChange}
      testid={testid}
      placeholder="Set a reminder"
      title="Set reminder"
      icon={Bell}
      disablePast
    />
  );
}
